// src/pages/auth/ResetPasswordRequest.jsx
import React, { useState } from 'react';
import { Form, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../../services/api';
import '../../styles/login.css';

const ResetPasswordRequest = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setLoading(true);

    try {
      const response = await apiClient.post(
        '/auth/password/reset/',
        { email }
      );

      if (response.status === 200) {
        setSuccess(true);
        setEmail(''); // Clear the form
      }
    } catch (err) {
      // Always show the same message for security (no email enumeration)
      setSuccess(true);
      setEmail('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form">
      <h2>Reset Password</h2>
      <p className="text-muted mb-4">
        Enter your email address and we'll send you a link to reset your password.
      </p>

      {success && (
        <Alert variant="success">
          If an account exists with this email, a reset link has been sent. Please check your inbox.
        </Alert>
      )}

      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
        </Form.Group>

        <button
          type="submit"
          disabled={loading || !email}
          className="ff-btn ff-btn--primary ff-btn--block"
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </Form>

      <div className="signup-redirect mt-3 text-center">
        <span>
          Remember your password?{' '}
          <span className="signup-link" onClick={() => navigate('/login')} role="button">
            Back to Login
          </span>
        </span>
      </div>
    </div>
  );
};

export default ResetPasswordRequest;
